import script from "./ProjectDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=1f06c476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f06c476"]])

export default __exports__